import { Badge, cn } from '@staff-app/ui';
import {
  ACTION_CATEGORY_MAP,
  ACTION_TYPE_LABELS,
  BADGE_COLORS,
  type ActionBadgeCategory,
} from '../lib/audit-constants';

/** Vendored from scio3 `AuditLogActionBadge` — same label + colour the customer sees. */
export function AuditActionBadge({ action }: { action?: number | null }) {
  const category: ActionBadgeCategory =
    action == null ? 'EDIT' : ACTION_CATEGORY_MAP[action] || 'EDIT';
  const colors = BADGE_COLORS[category];
  const label = action == null ? 'Unknown' : ACTION_TYPE_LABELS[action] || `Action ${action}`;
  return (
    <Badge variant="outline" className={cn('rounded-md border-0 whitespace-nowrap', colors.bg, colors.text)}>
      {label}
    </Badge>
  );
}
